import {
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import PatientDetailsComponent from "../../../PatientCare/Nursing/vitals/components/DetailsCard";
import LabResult from "./LabResult";
import LabList from "./LabList";
import { Button, Paper, Typography } from "@mui/material";
import { LabDataType, LabItemType, LabTemplateType } from "../type";
import dayjs from "dayjs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { dateFormat } from "./SaveSpecimendate";
import { EmrDataProvider } from "../../../EMR";
export type ContextType = {
  resultView: LabItemType | null;
  setResultView: Dispatch<SetStateAction<LabItemType | null>>;
  selectedTemplate: LabTemplateType | null;
  setSelectedTemplate: Dispatch<SetStateAction<LabTemplateType | null>>;
  labData: { specimenReceivedDateTime: string; data: LabDataType[] };
  setLabData: Dispatch<
    SetStateAction<{ specimenReceivedDateTime: string; data: LabDataType[] }>
  >;
  checkAbnormalFlag: any;
  setCheckAbnormalFlag: Dispatch<SetStateAction<any>>;
  isResultSaved: boolean;
  setIsResultSaved: Dispatch<SetStateAction<boolean>>;
  editData: {
    [key: number]: {
      value: string;
      abnormalFlagId: number;
      abnormalFlagName: string;
    };
  };
  setEditData: Dispatch<
    SetStateAction<{
      [key: number]: {
        value: string;
        abnormalFlagId: number;
        abnormalFlagName: string;
      };
    }>
  >;
};

export const LabContext = createContext<ContextType>({
  resultView: null,
  setResultView: () => {},
  selectedTemplate: null,
  setSelectedTemplate: () => {},
  labData: {
    specimenReceivedDateTime: dayjs().format(dateFormat),
    data: [],
  },
  setLabData: () => {},
  checkAbnormalFlag: {},
  setCheckAbnormalFlag: () => {},
  isResultSaved: false,
  setIsResultSaved: () => {},
  editData: {},
  setEditData: () => {},
});

const LabMainPage = () => {
  const navigateTo = useNavigate();
  const [resultView, setResultView] = useState<LabItemType | null>(null);
  const [selectedTemplate, setSelectedTemplate] =
    useState<LabTemplateType | null>(null);
  const [editData, setEditData] = useState<{
    [key: number]: {
      value: string;
      abnormalFlagId: number;
      abnormalFlagName: string;
    };
  }>({});
  const [isResultSaved, setIsResultSaved] = useState<boolean>(false);
  const [labData, setLabData] = useState<{
    specimenReceivedDateTime: string;
    data: LabDataType[];
  }>({
    specimenReceivedDateTime: "",
    data: [],
  });
  const [checkAbnormalFlag, setCheckAbnormalFlag] = useState<any>({});
  useEffect(() => {
    return () => {
      setResultView(null);
      setSelectedTemplate(null);
      setLabData({
        specimenReceivedDateTime: dayjs().format("DD-MM-YYYY HH:mm:ss"),
        data: [],
      });
    };
  }, []);
  const goBack = () => {
    navigateTo(-1);
  };
  return (
    <EmrDataProvider>
      <LabContext.Provider
        value={{
          resultView,
          setResultView,
          selectedTemplate,
          setSelectedTemplate,
          labData,
          setLabData,
          checkAbnormalFlag,
          setCheckAbnormalFlag,
          isResultSaved,
          setIsResultSaved,
          editData,
          setEditData,
        }}
      >
        <Paper
          sx={{ marginTop: "20px", marginX: "10px" }}
          className=" flex flex-col gap-y-3"
        >
          <div className="px-4 flex justify-between items-center pt-2">
            <Typography
              variant="h6"
              sx={(theme) => ({ color: theme.palette.primary.main })}
            >
              Lab Dashboard
            </Typography>
            <Button
              onClick={goBack}
              color="error"
              startIcon={<ArrowBackIcon />}
            >
              back
            </Button>
          </div>
          <PatientDetailsComponent />
          {Boolean(resultView) ? <LabResult /> : <LabList />}
        </Paper>
      </LabContext.Provider>
    </EmrDataProvider>
  );
};
export default LabMainPage;
